import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { TimePicker } from '@mui/x-date-pickers/TimePicker'
import { type Dayjs, dayjs } from '../dayjs.ts'
import { ids } from '../ids.ts'
import { Stack } from './Stack.tsx'

export const TimeRangePicker = ({ startLabel, endLabel, startValue, endValue, onChange, disabled }: TimeRangePickerProps) => {
	const handleStartTimeChange = (value: Dayjs | null) => {
		if (!value) return
		onChange(value.format('HH:mm'), endValue)
	}
	const handleEndTimeChange = (value: Dayjs | null) => {
		if (!value) return
		onChange(startValue, value.format('HH:mm'))
	}

	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<Stack>
				<TimePicker
					// @ts-expect-error data-* types missing from props
					slotProps={{ textField: { 'data-ta': ids.preferences.notifications.snooze.start } }}
					views={['hours', 'minutes']}
					label={startLabel}
					value={dayjs(startValue, 'HH:mm')}
					onChange={handleStartTimeChange}
					disabled={disabled}
					sx={{ w: 160 }}
				/>
				<TimePicker
					// @ts-expect-error data-* types missing from props
					slotProps={{ textField: { 'data-ta': ids.preferences.notifications.snooze.end } }}
					views={['hours', 'minutes']}
					label={endLabel}
					value={dayjs(endValue, 'HH:mm')}
					onChange={handleEndTimeChange}
					disabled={disabled}
					sx={{ w: 160 }}
				/>
			</Stack>
		</LocalizationProvider>
	)
}

type TimeRangePickerProps = {
	startLabel: string
	endLabel: string
	startValue: string
	endValue: string
	disabled?: boolean
	onChange: (startValue: string, endValue: string) => void
}
